class Nav {
  constructor() {
    this.toggleMenuBtn = document.getElementById('toggle-nav')
    this.toggleProjectsBtn = document.getElementById('toggle-projects')
    this.menuWrapper = document.querySelector('#menu_wrapper')
    this.menuLinks = document.querySelectorAll('.menu-item a')
    this.events()
    this.setActiveMenuLink()
  }

  events() {
    // Open and Close the Nav Menu
    this.toggleMenuBtn.addEventListener('click', () => this.toggleNavMenu())

  }

  toggleNavMenu() {
    this.toggleMenuBtn.classList.toggle('active')
    document.body.classList.toggle('noScroll')
    this.menuWrapper.classList.toggle('expand')
  }

  setActiveMenuLink() {
    this.menuLinks.forEach(function (link) {
      if (link.href === window.location.href) {
        link.classList.add('active-highlight')
      }
    })
  }
}

export default Nav
